<template>
  <v-row class="fill-height" justify="center" align="center">
    <v-card disabled outlined max-width="500" class="">
      <v-card-title primary-title>
        {{ $t('views.portfolio.empty.title') }}
      </v-card-title>
      <v-card-text>
        {{ $t('views.portfolio.empty.description') }}
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
export default {
  name: 'PortfolioEmpty',
};
</script>
